export const fixedRoutes = [
  '/add-job',
  '/jobs/',
  '/import-job',
];



// WEBPACK FOOTER //
// ./src/components/Header/constants.js